
// import { staffList } from '../config/apiUrl'
import API from '../services';
const { getStaffList } = API.dataqin

const getStaffListData = async (params, _isBrowser) => {
    return new Promise(resolve => {
        staffList(params, _isBrowser).then((result) => {
            resolve({
                record: result
            })
       })
    })
}


export default {
    namespace: 'team',
    state: {
        stafflist: [],
    },
    reducers: {
        initStaff(state, { payload }) {
            let newStaffList = []
            for(let i=0;i< payload.length;i+=3){
                newStaffList.push(payload.slice(i, i+3))
            }
            return {
              ...state,
              stafflist: newStaffList
            }
        }
    },
    effects: {
        *setStaff({ payload }, {put}) {
            yield put({
                type: 'initStaff',
                payload: payload.record
            })
        },
        // 获取员工风采
        *getStaffList({ payload, _isBrowser }, { call, put }) {
            const result = yield call(getStaffList, payload, _isBrowser)
            // 成功
            yield put({
                type: 'initStaff',
                payload: result
            })
           
        }
    }
}